import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { formatTurnDescription, formatTurnCell } from "../Game/scoreboardUtils";
import "./scoreboard.css";

const ScoreBoard = ({players, scoreBoard, info, style}) => {
    const rounds = scoreBoard?.rounds || [];

    return (
        <div style={style} className="scoreboard-container">
            <h3>Score Board</h3>
            <table className="table table-striped table-sm scoreboard-table">
                <thead>
                    <tr>
                        <th>Round</th>
                        {players?.map((player, i) => (
                            <th key={i}>{player.name}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rounds.map((round, roundIndex) => (
                        <tr key={roundIndex}>
                            <td className="round-number">{roundIndex + 1}</td>
                            {players?.map((_, playerIndex) => {
                                const turn = round.turns?.[playerIndex];
                                const cellLabel = turn ? formatTurnCell(turn) : null;
                                const tooltip = turn?.type === "word"
                                    ? formatTurnDescription(turn)
                                    : null;
                                return (
                                    <td key={playerIndex}>
                                        {turn ? (
                                            <>
                                                <div className="turn-cell">
                                                    {tooltip ? (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip>{tooltip}</Tooltip>
                                                            }
                                                        >
                                                            <span className="turn-score" role="button">{cellLabel}</span>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <span className="turn-label">{cellLabel}</span>
                                                    )}
                                                </div>
                                                <div className="cumulative-score fw-bold">{turn.culmulativeScore}</div>
                                            </>
                                        ) : null}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ScoreBoard;